import getValueReduxUtil from 'modules/redux/utils/get-value'
import { TRAINING_PLAN_KEY } from 'modules/training/models/plan/constants'

function getNamePlanUtil (instance) {
  return getValueReduxUtil(
    instance, TRAINING_PLAN_KEY.NAME
  )
}

export default getNamePlanUtil
